import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import GifDetail from '../components/detail'
import * as selectors from 'shared/redux/reducers'
import { gifUrl, getNewPermissions } from 'shared/api'
import { setUserPermissions, resetUserPermissions } from 'shared/redux/permissions'
import { setEditModeChannels } from 'shared/redux/edit-mode-channels'
import log from 'shared/util/log'
import { fetchGifs, fetchGifsFromUrl } from 'shared/redux/fetch-gifs'
import fetchChannels from 'shared/redux/fetch-channels'
import { debounce, isEmpty } from 'lodash'

const FETCH_DEBOUNCE = 1000

/**
 * Don't render the GifDetail without a gif
 * If there's no gif, fetch one with the gif id
 * Also, fetch pagination gifs
 */
class EnsureGif extends PureComponent {
    static defaultProps = {
        relatedGifs: [],
    }
    componentDidUpdate(prevProps) {
        const { gif, fetchGifsFromUrl, gifId, relatedGifs, groupId, isRemoved, user = {} } = this.props
        if (isRemoved) {
            const { username } = user
            location.href = username ? `/channel/${username}` : `/`
            return
        }
        if (!gif && gifId) {
            /**
             * Fires on history popstate
             * If we knew which direction we were going
             * forward or backward, we could prepend
             * or append the gif set, but we don't know
             */
            fetchGifsFromUrl(gifUrl(gifId), { groupId })
        }
        if (!relatedGifs.length && gifId !== prevProps.gifId) {
            this.queueRelatedGifsFetch()
        }
        // avoid errors when a gif is deleted
        if (gif && prevProps.gif && gif.id !== prevProps.gif.id) {
            this.getNewGifData()
        }
    }
    componentDidMount() {
        this.getRelatedGifs()
        this.getNewGifData()
    }
    getRelatedGifs = () => {
        const { gifId, fetchGifs, fetchGifsFromUrl, relatedGroupId, relatedGifs } = this.props
        if (relatedGifs.length) {
            fetchGifs({ groupId: relatedGroupId })
        } else {
            fetchGifsFromUrl(`/gifs/${gifId}/related/1`, { groupId: relatedGroupId, report: false })
        }
    }
    queueRelatedGifsFetch = debounce(this.getRelatedGifs, FETCH_DEBOUNCE)
    getNewGifData = debounce(async () => {
        // gets new user permissions and view count & resets the schema markup

        const {
            gif,
            setUserPermissions,
            resetUserPermissions,
            setChannels,
            fetchChannels,
            channelSelectorItems,
            user,
        } = this.props

        const { id } = gif

        if (!user.loggedIn) {
            resetUserPermissions()
            return
        }

        try {
            const {
                permissions,
                gif: { channels },
            } = await getNewPermissions(id)
            setUserPermissions(permissions)
            if (permissions.channel) {
                setChannels(channels) // sets the gif's channels
                if (!channelSelectorItems || (channelSelectorItems && isEmpty(channelSelectorItems.channels))) {
                    fetchChannels() // fetches all channels to populate channel selector if we don't already have them
                }
            }
        } catch (e) {
            resetUserPermissions()
            log.error(`Error getting gif view count ${e}`)
        }
    }, FETCH_DEBOUNCE)
    render() {
        const { gif, isRemoved } = this.props
        return <div>{gif && !isRemoved && <GifDetail {...this.props} />}</div>
    }
}

export default connect(
    (state, { gifId, groupId }) => {
        const relatedGroupId = `${gifId}-related`
        return {
            relatedGroupId,
            gif: selectors.getGifById(state, gifId, groupId),
            nextGif: selectors.getNextGif(state, gifId, groupId || relatedGroupId),
            prevGif: selectors.getPrevGif(state, gifId, groupId || relatedGroupId),
            relatedGifs: selectors.getGifs(state, relatedGroupId),
            permissions: selectors.getUserPermissions(state),
            editModeChannels: selectors.getEditModeChannels(state),
            channelSelectorItems: state.channelSelectorItems,
            user: selectors.getUser(state),
            isRemoved: selectors.getRemovedGifs(state).indexOf(gifId) !== -1,
        }
    },
    {
        fetchGifsFromUrl,
        resetUserPermissions,
        fetchGifs,
        setUserPermissions,
        setEditModeChannels,
        fetchChannels,
    },
)(EnsureGif)
